import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import '../html-template/select-tool.scss';

class SelectTool extends Component {
    render(){
        return (
        <main className="container select-tool">
            <div className="content-wrapper">
                <div className="content-right-wrapper survey">
									<Link to="/mau-xe/" className="tool-link">
										<img src={process.env.PUBLIC_URL + '/assets/moto.svg'}/>
									Xem màu xe</Link>
									<Link to="/to-mau" className="tool-link">
										<img src={process.env.PUBLIC_URL + '/assets/paint.svg'}/>
									Tô màu</Link>
									<Link to="/show-cards" className="tool-link">
										<img src={process.env.PUBLIC_URL + '/assets/showcard.svg'}/>
									Show cards</Link>
                </div>
            </div>
        </main>
        );
    }
}

export default SelectTool;
